import {
    earliestAustralianDate,
    earliestNewZealandDate,
    useMediaValueContext
} from '~/services/mediaValue/mediaValueContext';
import {subtract, now} from 'stringdate';
import {useCountry} from '~/feature/country/CountryContext';
import {AU} from 'bigdatr-style';

export default function useDatePickerMinAndMaxDates(
    props:
        | {
              type: 'spend';
              includeForecasted?: boolean;
          }
        | {type: 'creative'}
) {
    const meta = useMediaValueContext({enabled: props.type === 'spend'});
    const {country} = useCountry();

    if (props.type === 'creative') {
        if (country === AU) {
            return {
                minValue: earliestAustralianDate,
                maxValue: now()
            };
        }
        return {
            minValue: earliestNewZealandDate,
            maxValue: now()
        };
    }

    let maxValue = subtract('P1M')(meta.forecastCutoff);
    if (props.includeForecasted || country !== AU) {
        maxValue = meta.endDate;
    }

    return {minValue: meta.startDate, maxValue};
}
